export const WRITE_TO_GP_SPECIALIST = "WRITE_TO_GP_SPECIALIST";
export const SEND_LETTER_TO_GP_SPECIALIST = "SEND_LETTER_TO_GP_SPECIALIST";
